import { pictureTypes, mapSelectOptions } from 'src/processes/CMS/processes/management/pages/BuilderPage/Condition/Actions/actionConstants';

const EXCLUDED_IMAGE_IDS = new Set(['lowSaturation', '']);

/**
 * @desc Picture type options for the image selection flow, Chapter icon only for product-based finders
 * or for a rule that already has it saved, otherwise the select loses the selected value
 * @param {Object} params
 * @param {Boolean} params.isProductBasedFinder
 * @param {String} params.pictureType - picture type saved in the rule
 * @returns {Array<{title: String, value: String}>}
 */
export const getPictureTypeOptions = ({ isProductBasedFinder, pictureType }) => {
  const options = [pictureTypes.active, pictureTypes.inactive];

  if (isProductBasedFinder || pictureType === pictureTypes.chapterIcon) {
    options.push(pictureTypes.chapterIcon);
  }

  return mapSelectOptions(options);
};

const getImageSource = ({ pictureType, selectedChapter, media, chapterIconMedia }) => {
  if (pictureType === pictureTypes.chapterIcon) {
    return { imageIds: selectedChapter?.chapterIcons, mediaList: chapterIconMedia };
  }

  if (pictureType === pictureTypes.active) {
    return { imageIds: selectedChapter?.activeImages, mediaList: media };
  }

  return { imageIds: selectedChapter?.inactiveImages, mediaList: media };
};

/**
 * @desc Image options of the selected chapter for the chosen picture type
 * @param {Object} params
 * @param {String} params.pictureType
 * @param {Object} params.selectedChapter - chapter option from useElements
 * @param {Array} params.media - finder background media
 * @param {Array} params.chapterIconMedia - finder chapter icon media
 * @returns {Array<{title: String, value: String, imageUrl: String}>}
 */
export const getFlowImageOptions = ({ pictureType, selectedChapter, media, chapterIconMedia }) => {
  const source = getImageSource({ pictureType, selectedChapter, media, chapterIconMedia });
  const imageIds = source.imageIds || [];
  const mediaList = source.mediaList || [];
  const imageOptions = [];

  for (const imageId of imageIds.filter(id => !EXCLUDED_IMAGE_IDS.has(id))) {
    const imageData = mediaList.find(mediaItem => mediaItem.id === imageId);
    const { s3Url, originalFileName } = imageData || {};

    if (s3Url) {
      imageOptions.push({
        title: originalFileName,
        value: imageId,
        imageUrl: s3Url,
      });
    }
  }

  return imageOptions;
};
